'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactSpinkit = require('react-spinkit');

var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BisuReactLoading = function BisuReactLoading(_ref) {
  var name = _ref.name,
      overlay = _ref.overlay,
      text = _ref.text;

  var cl = (0, _classnames2.default)('bisu--react-loading', { 'is_overlay': overlay });
  return _react2.default.createElement(
    'div',
    { className: cl },
    _react2.default.createElement(_reactSpinkit2.default, { spinnerName: name, noFadeIn: true }),
    _react2.default.createElement(
      'div',
      { className: 'text-center' },
      _react2.default.createElement(
        'small',
        null,
        _react2.default.createElement(
          'em',
          null,
          text
        )
      )
    )
  );
};

BisuReactLoading.defaultProps = {
  name: 'cube-grid'
};

exports.default = BisuReactLoading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-loading/lib/index.js
// module id = 34
// module chunks = 0